export default "__VITE_ASSET__D1$Oahr8__"